import { ModalContext } from "@/pages/_app";
import { useContext } from "react";

import ForgotPassword from "../forms/auth/forgot/ForgotPassword";
import OtpMobile from "../forms/auth/forgot/OtpMobile";
import AuthModal from "./AuthModal";
import Filter from "./Filter";
import SortBy from "./SortBy";
import VerifyOtp from "../forms/checkout/payments/VerifyOtp";
import SideMenu from "./side-menu/SideMenu";
import EditAddresses from "./checkout/EditAddresses";
import AddNewAddress from "./checkout/AddNewAddress";
import EditAddress from "./checkout/EditAddress";
import VideoModal from "./VideoModal";
import TrackOrderModal from "./TrackOrderModal";
import CartInfo from "./AddToCartInfo";
import BookServiceModal from "./book-service/BookServiceModal";
import ForgotPasswordEmail from "../forms/auth/forgot/ForgotPasswordEmail";
import OtpEmail from "../forms/auth/login/OtpEmail";
import ChangePassByEmail from "../forms/auth/login/ChangePassByEmail";
import ChangePassByMobile from "../forms/auth/login/ChangePassByMobile";
import OtpLoginMobile from "../forms/auth/login/OtpLoginMobile";
import TabbyModal from "@/components/modals/TabbyModal";

const Modals = () => {
  const Context = useContext(ModalContext);
  if (Context?.state?.modal) {
    return (
      <div className="fixed top-0 left-0 flex items-center justify-center w-screen h-screen bg-black bg-opacity-60 z-modal">
        {Context?.state.videoModal ? <VideoModal Context={Context} /> : null}
        {Context?.state.auth ? <AuthModal Context={Context} /> : null}
        {Context?.state.otp ? <OtpMobile Context={Context} /> : null}
        {Context?.state.verifyOtpLoginMobile ? (
          <OtpLoginMobile Context={Context} />
        ) : null}
        {Context?.state.otpEmail ? <OtpEmail Context={Context} /> : null}
        {Context?.state.changePassByEmail ? (
          <ChangePassByEmail Context={Context} />
        ) : null}
        {Context?.state.changePassByMobile ? (
          <ChangePassByMobile Context={Context} />
        ) : null}
        {Context?.state.forgot ? <ForgotPassword Context={Context} /> : null}
        {Context?.state.forgotEmail ? (
          <ForgotPasswordEmail Context={Context} />
        ) : null}
        {Context?.state.filter ? <Filter Context={Context} /> : null}
        {Context?.state.sortBy ? <SortBy Context={Context} /> : null}
        {Context?.state.cartInfo ? <CartInfo Context={Context} /> : null}
        {Context?.state.editAddresses ? (
          <EditAddresses Context={Context} />
        ) : null}
        {Context?.state.addNewAddress ? (
          <AddNewAddress Context={Context} />
        ) : null}
        {Context?.state.editAddress ? <EditAddress Context={Context} /> : null}
        {Context?.state.stcPayOtp ? <VerifyOtp Context={Context} /> : null}
        {Context?.state.trackOrder ? (
          <TrackOrderModal Context={Context} />
        ) : null}
        {Context?.state.bookService ? (
          <BookServiceModal Context={Context} />
        ) : null}
        {Context?.state.tabbyModal ? <TabbyModal  Context={Context} /> : null}
      </div>
    );
  } else if (Context?.state.sidemenu) {
    return <SideMenu Context={Context} />;
  }
};

export default Modals;
